import { ElRefDirective } from "@app/_directives/el-ref/el-ref.directive";

export const useSelectInput = () => (ev: Event, timeInput: ElRefDirective) => {
	const el: HTMLElement = timeInput.elementRef.nativeElement;
	if (!el) {
		return;
	}
	const input = el.querySelector("input");
	if (input) {
		ev.preventDefault();
		input.select();
	}
};
